import React, { useState, useEffect } from 'react';
import { CheckCircle, BookOpen, Loader2 } from 'lucide-react';
import RegistrationForm from '../components/RegistrationForm';
import ComingSoon from '../components/ComingSoon';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const RegisterPage = () => {
  const [step, setStep] = useState('loading'); // loading, form, success, offline
  const [backendAvailable, setBackendAvailable] = useState(false);

  useEffect(() => {
    checkBackend();
  }, []);

  const checkBackend = async () => {
    try {
      await axios.get(`${API}/api/health`, { timeout: 5000 });
      setBackendAvailable(true);
      setStep('form');
    } catch (err) {
      console.log('Backend not available');
      setBackendAvailable(false);
      setStep('offline');
    }
  };

  const handleSuccess = () => {
    setStep('success');
  };

  const handleBack = () => {
    window.location.href = '/';
  };

  if (step === 'loading') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-yellow-50 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="w-12 h-12 animate-spin text-purple-600 mx-auto" />
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (step === 'offline') {
    return <ComingSoon feature="Online Registration" />;
  }

  if (step === 'form') {
    return <RegistrationForm onSuccess={handleSuccess} onBack={handleBack} />;
  }

  // Success Page
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-teal-50 to-cyan-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-2xl p-8 w-full max-w-md text-center border-4 border-green-200">
        <div className="w-24 h-24 bg-gradient-to-r from-green-400 to-teal-500 rounded-full flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-14 h-14 text-white" />
        </div>
        
        <h1 className="text-3xl font-bold text-gray-800 mb-2">
          🎉 Registration Complete!
        </h1>
        
        <p className="text-gray-500 mb-6">
          Welcome to MINDSPACE Reading Room! Your registration has been submitted successfully.
        </p>

        <div className="bg-gradient-to-r from-purple-50 to-pink-50 p-4 rounded-xl mb-6">
          <p className="text-sm text-gray-600 mb-2">Payment Status</p>
          <p className="text-lg font-bold text-yellow-600">⏳ Pending Verification</p>
          <p className="text-xs text-gray-500 mt-1">
            Our team will verify your payment and confirm your seat.
          </p>
        </div>

        <div className="space-y-3">
          <a
            href="/"
            className="block w-full py-3 bg-gradient-to-r from-purple-600 to-pink-600 text-white rounded-xl font-bold hover:opacity-90 transition"
          >
            <BookOpen className="w-5 h-5 inline mr-2" />
            Back to Home
          </a>
          
          <a
            href="https://wa.me/919398869329?text=Hi! I just registered at MINDSPACE Reading Room. My registration is pending verification."
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full py-3 bg-green-500 text-white rounded-xl font-bold hover:bg-green-600 transition"
          >
            💬 Contact on WhatsApp
          </a>
        </div>

        <p className="text-xs text-gray-400 mt-6">
          For any queries, call us at 9398869329
        </p>
      </div>
    </div>
  );
};

export default RegisterPage;
